import PropTypes from 'prop-types';
import React from 'react';
import { ContainerJanela, Divisor, Linha } from '../../styles/base';
import Botao from '../Botao/Botao';
import { Acessibilidade, JanelaAcessibilidade, TituloAcessibilidade } from './ModalAcessibilidadeEstilo';

const ModalAcessibilidade = ({ fecharModal, contrast }) => (
  <ContainerJanela>
    <JanelaAcessibilidade contrast={contrast}>
      <Linha style={{ justifyContent: 'flex-end' }}>
        <Botao
          fechar
          onClick={fecharModal}
        />
      </Linha>

      <TituloAcessibilidade>eOuve - Acessibilidade</TituloAcessibilidade>

      <Divisor />

      <Acessibilidade>
        O Sistema de Ouvidoria eOuve foi construído a partir de pesquisas sobre usabilidade e acessibilidade. Usabilidade para que os usuários encontrem as informações desejadas de forma mais fácil e intuitiva, e acessibilidade para incluir todos os cidadãos no uso dos produtos, serviços e informações disponibilizados pela instituição na internet.
        <br />
        <br />
        Seguindo padrões internacionais como o World Content Accessibility Guide (WCAG) e o Modelo de Acessibilidade em Governo Eletrônico (e-MAG) estabelecido federalmente pela Portaria nº 03, de 07 de Maio de 2007, o Sistema de Ouvidoria eOuve deseja assim oferecer um melhor acesso a rede de informações em formatos alternativos e inclusivos.
        <br />
        <br />
        A acessibilidade no Sistema de Ouvidoria eOuve está inserida na programação HTML das páginas e é automaticamente identificada por programas de leitura de tela como o Jaws e o Voiceover. Além disso, é possível controlar o tamanho das letras nas páginas e o contraste das cores por meio de botões localizados na barra de acessibilidade do Portal.
        <br />
        <br />
        Leis e decretos sobre acessibilidade:
        <br />
        <br />
        • Decreto nº 5.296, de 02 de dezembro de 2004 - Regulamenta as leis nº 10.048, de 8 de novembro de 2000, que dá prioridade de atendimento às pessoas que especifica, e nº 10.098, de 19 de dezembro de 2000, que estabelece normas gerais e critérios básicos para a promoção da acessibilidade das pessoas portadoras de deficiência ou com mobilidade reduzida, e dá outras providências.
        <br />
        <br />
        • Decreto nº 6.949, de 25 de agosto de 2009 - Promulga a Convenção Internacional sobre os Direitos das Pessoas com Deficiência e seu Protocolo Facultativo, assinados em Nova York, em 30 de março de 2007.
        <br />
        <br />
        • Decreto nº 7.724, de 16 de Maio de 2012 - Regulamenta a lei que dispõe sobre o acesso a informações.
        <br />
        <br />
        • Lei nº 13.146, de 06 de julho de 2015 - Art. 63: É obrigatória a acessibilidade nos sítios da internet mantidos por empresas com sede ou representação comercial no País ou por órgãos de governo, para uso da pessoa com deficiência, garantindo-lhe acesso às informações disponíveis, conforme as melhores práticas e diretrizes de acessibilidade adotadas internacionalmente. § 1o Os sítios devem conter símbolo de acessibilidade em destaque.
      </Acessibilidade>
    </JanelaAcessibilidade>
  </ContainerJanela>
);

ModalAcessibilidade.propTypes = {
  fecharModal: PropTypes.func,
  contrast: PropTypes.bool,
};

ModalAcessibilidade.defaultProps = {
  fecharModal: null,
  contrast: false,
};

export default ModalAcessibilidade;
